<div class="app-grid">
    <div class="columns-8">
        <form *ngIf="!isReseting" #form="ngForm" class="app-grid" autocomplete="off">
            <!-- income type -->
            <mat-form-field *ngIf="editMode" class="columns-12">
                <mat-label>{{ 'components.edit-company-additional-income.incomeType' | appTranslate }}</mat-label>
                <input matInput disabled class="read-only" type="text" [value]="companyAdditionalIncome.displayName" />
            </mat-form-field>

            <mat-form-field *ngIf="!editMode" class="columns-12">
                <mat-label appRemoveAriaOwns>{{
                    'components.edit-company-additional-income.incomeType' | appTranslate
                }}</mat-label>
                <mat-select
                    name="selectedCompanyAdditionalIncome"
                    #selectedCompanyAdditionalIncome="ngModel"
                    required
                    [(ngModel)]="companyAdditionalIncome"
                    placeholder="{{ 'components.edit-company-additional-income.selectOptions' | appTranslate }}"
                >
                    <mat-option
                        *ngFor="let companyAdditionalIncome of allCompanyAdditionalIncomes"
                        [disabled]="companyAdditionalIncome.active"
                        [value]="companyAdditionalIncome"
                        >{{ companyAdditionalIncome.displayName }}</mat-option
                    >
                </mat-select>

                <mat-error *ngIf="selectedCompanyAdditionalIncome.invalid">{{
                    selectedCompanyAdditionalIncome.errors | formErrors
                }}</mat-error>
            </mat-form-field>

            <!-- Description -->
            <mat-form-field *ngIf="companyAdditionalIncome" class="columns-12">
                <mat-label>{{ 'components.edit-company-additional-income.description' | appTranslate }}</mat-label>
                <input
                    matInput
                    [disabled]="!companyAdditionalIncome"
                    name="description"
                    [(ngModel)]="companyAdditionalIncome.description"
                    #description="ngModel"
                    placeholder="{{
                        'components.edit-company-additional-income.descriptionPlaceholder' | appTranslate
                    }}"
                    type="text"
                />
            </mat-form-field>

            <mat-form-field *ngIf="!companyAdditionalIncome" class="columns-12">
                <mat-label>{{ 'components.edit-company-additional-income.description' | appTranslate }}</mat-label>
                <input
                    matInput
                    disabled
                    name="description"
                    placeholder="{{
                        'components.edit-company-additional-income.descriptionPlaceholder' | appTranslate
                    }}"
                    type="text"
                />
            </mat-form-field>
        </form>
    </div>

    <form class="ui form columns-4">
        <div class="inline field">
            <label style="padding-top: 0">{{
                'components.edit-company-additional-income.taxesAndCalculationsApplied' | appTranslate
            }}</label>
            <div style="padding: 16px" class="ui segment">
                <ng-content></ng-content>
            </div>
        </div>
    </form>
</div>
